import { render, staticRenderFns } from "./CloseButton.vue?vue&type=template&id=fae2af1c&scoped=true&"
import script from "./CloseButton.vue?vue&type=script&lang=ts&"
export * from "./CloseButton.vue?vue&type=script&lang=ts&"
import style0 from "./CloseButton.vue?vue&type=style&index=0&id=fae2af1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fae2af1c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
